import './Footer.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">₿ook of Secrets</h3>
            <p className="footer-description">
              Decentralized secrets on Bitcoin. Built on Citrea testnet.
            </p>
            <div className="footer-badges">
              <span className="badge-item">🔗 Citrea</span>
              <span className="badge-item">₿ cBTC</span>
              <span className="badge-item">🔐 Encrypted</span>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/profile">Profile</a></li>
              <li><a href="/book">My Book</a></li>
              <li><a href="/create">Create Page</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Resources</h4>
            <ul className="footer-links">
              <li><a href="https://citrea.xyz" target="_blank" rel="noopener noreferrer">Citrea Docs</a></li>
              <li><a href="https://explorer.testnet.citrea.xyz" target="_blank" rel="noopener noreferrer">Explorer</a></li>
              <li><a href="https://github.com" target="_blank" rel="noopener noreferrer">GitHub</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Network</h4>
            <div className="network-info">
              <div className="network-item">
                <span className="network-label">Chain ID:</span>
                <span className="network-value">5115</span>
              </div>
              <div className="network-item">
                <span className="network-label">Currency:</span>
                <span className="network-value">cBTC</span>
              </div>
              <div className="network-item">
                <span className="network-label">Network:</span>
                <span className="network-value">Testnet</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Book of Secrets. Built for Citrea Ecosystem.
          </p>
          <div className="footer-socials">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
              𝕏
            </a>
            <a href="https://discord.com" target="_blank" rel="noopener noreferrer" className="social-link">
              Discord
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">
              GitHub
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
